(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabActionsQueueDetailController', TabActionsQueueDetailController);

    TabActionsQueueDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity'];

    function TabActionsQueueDetailController($scope, $rootScope, $stateParams, entity) {
        var vm = this;
        vm.group = $stateParams.group;
        vm.tabActionsQueue = entity;
        var unsubscribe = $rootScope.$on('jotApp:tabActionsQueueUpdate', function(event, result) {
            vm.tabActionsQueue = result;

        });
        $scope.$on('$destroy', unsubscribe);



    }
})();
